import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { markInputRule } from '../../utils';
import plugins from './plugins';

const ITALIC_NODE_NAME = 'em';
const ITALIC_REGEX = /(?:^|[^_a-zA-Z0-9])(_([^_]+)_)$/;
const ITALIC_REGEX_2 = /(?:^|[^*a-zA-Z0-9])(\*([^*]+)\*)$/;

export default class Italic extends BaseExtension {
  get schema(): MarkSpec {
    return {
      parseDOM: [{ tag: 'i' }, { tag: 'em' }, { style: 'font-style=italic' }],
      toDOM: () => ['em', 0],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return ITALIC_NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      mark: ITALIC_NODE_NAME,
    };
  }

  inputRules({ schema }: EditorOptions) {
    return [
      markInputRule(ITALIC_REGEX, schema.marks.em),
      markInputRule(ITALIC_REGEX_2, schema.marks.em),
    ];
  }

  plugins = plugins;
}
